<template>
    <div class="ts-finder__filterpanel">
        <button @click="closeFilters" class="ts-finder__filterpanel-close"><i class="fas fa-times"></i></button>

        <div class="ts-finder__filterpanel-top">
            <div class="ts-finder__filterpanel-title" v-show="migrolTabActive" v-html="strings['TsFinder.Map.FilterMigrol']"></div>
            <div class="ts-finder__filterpanel-title" v-show="!migrolTabActive" v-html="strings['TsFinder.Map.FilterAkzeptanzstellen']"></div>
            <div class="ts-finder__filterpanel-tabs">
                <div class="ts-finder__filterpanel-tab" @click="applyMigrolcardFilter(true)" :class="{ active: migrolTabActive }">{{strings['TsFinder.Map.TabLocations']}} <span class="ts-finder__filterpanel-tab-count ts-finder__filterpanel-filter-count">({{amountOnApplyMigrol}})</span></div>
                <div class="ts-finder__filterpanel-tab" @click="applyMigrolcardFilter(false)" :class="{ active: !migrolTabActive }">{{strings['TsFinder.Map.TabAkzeptanzstellen']}} <span class="ts-finder__filterpanel-tab-count ts-finder__filterpanel-filter-count">({{amountOnApplyMigrolcard}})</span></div>
            </div>
        </div>
        <div class="ts-finder__filterpanel-mid">
            <capability-filter />
            <canton-filter />
        </div>
        <div class="ts-finder__filterpanel-bottom">
            <button @click="closeFilters" class="ts-finder__filterpanel-show-stations">{{amountFiltered}} {{amountFiltered > 1 ? strings['TsFinder.Map.ShowLocations'] : strings['TsFinder.Map.ShowLocation']}}</button>
            <pdf-download-button />
            <button @click="resetAllFilters" class="ts-finder__filterpanel-reset"><i class="fas fa-undo-alt"></i> {{strings['TsFinder.Map.ResetFilters']}}</button>
        </div>
    </div>
</template>

<script>
    import CapabilityFilter from './CapabilityFilter.vue'
    import CantonFilter from './CantonFilter.vue'
    import PdfDownloadButton from '../PdfDownloadButton.vue'
    import { mapState, mapActions } from 'vuex'
    import * as R from 'ramda'
    import * as FilterHelper from '../../../utils/stationfilter'

    export default {
        components: {
            CapabilityFilter,
            CantonFilter,
            PdfDownloadButton
        },
        computed: {
            ...mapState([
                'filteredStations',
                'selectedCapabilityFilters',
                'filteredStationsForMigrolcardCount',
                'baseFilters',
                'strings'
            ]),
            migrolTabActive() {
                return FilterHelper.isCapabilityFilterActive(this.selectedCapabilityFilters, this.baseFilters.migrolcard);
            },
            amountOnApplyMigrol() {
                return R.filter((station) => station.capabilities.includes(this.baseFilters.migrolcard.filter), this.filteredStationsForMigrolcardCount).length;
            },
            amountOnApplyMigrolcard() {
                return this.filteredStationsForMigrolcardCount.length;
            },
            amountFiltered() {
                return this.filteredStations.length;
            }
        },
        methods: {
            ...mapActions([
                'setFilterViewComponent',
                'addCapabilityFilter',
                'removeCapabilityFilter',
                'resetAllFilters'
            ]),
            closeFilters() {
                this.setFilterViewComponent('search-box');
            },
            applyMigrolcardFilter(selected) {
                if (selected) {
                    this.addCapabilityFilter({ filter: this.baseFilters.migrolcard });
                }
                else {
                    this.removeCapabilityFilter({ filter: this.baseFilters.migrolcard });
                }
            }
        }
    };
</script>